export const ERROR_CODES = [
    "VALIDATION_ERROR",
    "PERSISTED_INTEGER_INVALID",
    "CSV_INVALID",
    "UNAUTHENTICATED",
    "FORBIDDEN",
    "AUTH_RESTRICTED",
    "CONFLICT",
    "RATE_LIMITED",
    "NOT_FOUND",
    "DEPENDENCY_UNAVAILABLE",
    "INTERNAL_ERROR",
];
export class ApplicationError extends Error {
    code;
    statusCode;
    details;
    constructor(code, message, options = {}) {
        super(message, options.cause === undefined ? undefined : { cause: options.cause });
        this.name = "ApplicationError";
        this.code = code;
        this.statusCode = options.statusCode ?? 400;
        this.details = options.details;
    }
}
export function toErrorResponse(error) {
    return {
        error: {
            code: error.code,
            message: error.message,
            ...(error.details === undefined ? {} : { details: error.details }),
        },
    };
}
//# sourceMappingURL=errors.js.map